module.exports = __webpack_public_path__ + "img/icon6.21c70a58.png";